define([
    'react',
    'lodash',
    './OnboardingHello',
    './OnboardingStatus'
], function (React, _, OnboardingHello, OnboardingStatus) {
    'use strict';
    return function () {
        return React.createElement('section', { 'className': true }    /*  b-onboarding__body  */, React.createElement('div', { 'className': 'l-container' }    /* 
        <OnboardingHello></OnboardingHello>
         */, React.createElement(OnboardingStatus, {})));
    };
});


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/onboarding/onboarding.html.rt
// module id = 4319
// module chunks = 86